module.exports = __webpack_public_path__ + "media/images/instagram-759a5ace43069c876f0459faa465a05b.png";